import { render, staticRenderFns } from "./CCBillFlexForm.vue?vue&type=template&id=0561a345&"
import script from "./CCBillFlexForm.vue?vue&type=script&lang=ts&"
export * from "./CCBillFlexForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports